import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { MessageContext,handleSuccessMessage } from "../../store/messageStore";
import { useCallback, useContext, useEffect, useState } from "react";
import { checkDpSuccess } from "../../utility/service/tool-service";
import { updateTsmpSetting } from "../../utility/service/setting-service";
import { useForm } from "react-hook-form";
import { addFormValidator } from "../../utility/validate/formValidator";
import { FormInput } from "../../components/FormInput";
import { FormTextarea } from "../../components/FormTextarea";
import { useEditableFlag } from "../../hooks/useEditableFlag";


export default function Setting_Detail(){

    const navigate = useNavigate();
    const { t } = useTranslation();
    const { itemObj,setItemObj,action,setAction } = useOutletContext();
    const [, dispatch] = useContext(MessageContext); //訊息視窗 
    const isEditable = useEditableFlag('B20103'); 

    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
      } = useForm({
        defaultValues: {
        },
        //錯誤驗證時機
        mode: "all"
      });


    const btnBackTo = ()=>{
        navigate(`/management/setting`);
    }

    useEffect(()=>{
        if(JSON.stringify(itemObj)!=='{}'){
            setValue("id",itemObj?.id);
            setValue("value",itemObj?.value);
            setValue("memo",itemObj?.memo);
        }else{
            btnBackTo();
        }
    },[itemObj])

    const onSubmit = (data) => {
        let reqBody = {
        id:data.id,
        value:data.value,
        memo:data.memo
        }
        updateTsmpSetting(reqBody)
             .then((res)=>{
                 if(checkDpSuccess(res)){
                     handleSuccessMessage(dispatch, t('button.update') + ' ' + t('message.success'));
                     btnBackTo();
                     
                 }
             })
 
        
       }

    const checkKeyDown = (e) => {
        if (e.keyCode === 13) {
          e.stopPropagation();
        }
      };
    
    const inputCheckKeyDown = (e) => { //避免觸發 按enter 後 就觸發 onSubmit 事件冒泡 給input 使用 <FormInput enterClick事件 ; 一般input onKeyDown事件
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    }

    return (
    <>
    {/* 返回上頁 */}
    <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
            <Button rounded text onClick={() => { btnBackTo(); }}>
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t('button.return_to_list')}
            </Button>
        </div>
    </div>
    <div className="p-card">
        <div className="p-card-body">
            <form onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
                <div className="grid">
                    <div className="col-12">
                        <FormInput
                            disabled={true}
                            register={register}
                            errors={errors}
                            id="id"
                            type="text"
                            labelClass={`control-label ${action==='create' ? 'required' : ''}`}
                            labelText={t('key')}
                            enterClick={inputCheckKeyDown} 
                        />
                    </div>
                    <div className="col-12">
                        <FormTextarea
                            disabled={action==='detail' || !isEditable}
                            register={register}
                            errors={errors}
                            id="value"
                            name="value"
                            type="text"
                            labelText={t('value')}
                            labelClass={`control-label ${action!=='detail' ? 'required' : ''}`}
                            areaClass="w-full"
                            rules={action!=='detail'?{required: t('validation.required')}:''}
                        />
                    </div>
                    <div className="col-12">
                        <FormTextarea
                            disabled={action==='detail' || !isEditable}
                            register={register}
                            errors={errors}
                            id="memo"
                            name="memo"
                            type="text"
                            labelText={t('remark')}
                            labelClass="control-label"
                            areaClass="w-full"
                        />
                    </div>
                </div>
                <div className="col-12 gap-2 flex-all-center">
              {
                ( action === 'detail') ?( <div className="col-12 gap-2 flex-all-center">
                    <Button disabled={!isEditable} label={t("button.edit")} onClick={(e) => {
                        e.preventDefault();
                        setAction('update');
                    }} type="button" size="small" />
                </div>):(<>
                    <Button disabled={!isValid || !isEditable} type="submit" label={t("button.confirm")} size="small" />
                    <Button outlined size="small" type="button" label={t("button.cancel")} onClick={(e) => {
                         btnBackTo();
                    }} />
                </>)
              }
            </div>
            </form>
        </div>
    </div>

    </>)
}